import React from "react";
import Box from "@mui/material/Box";
import { useNavigate, useLocation } from "react-router-dom";
import { isKbSubdomain } from "../../../../utils";

const RelatedArticles = ({ articles }) => {
    const navigate = useNavigate();
    const location = useLocation();

    if (!articles || articles.length === 0) return null;

    return (
        <Box
            sx={{
                width: "100%",
                minWidth: 0,
                overflow: "hidden",
                backgroundColor: "#FBFCFC",
                borderRadius: "8px",
                minHeight: "200px",
                padding: "24px",
                boxSizing: "border-box",
                display: "flex",
                flexDirection: "column",
            }}
        >
            <Box
                sx={{
                    fontSize: "20px",
                    fontWeight: 700,
                    color: "#0C141B",
                    fontFamily: "Inter",
                    marginBottom: "20px",
                }}
            >
                Related Articles
            </Box>

            {articles.map((item) => (
                <Box
                    key={item._id}
                    onClick={() => {
                        const query = location.search || "";
                        if (isKbSubdomain()) {
                            navigate(`/${item._id}${query}`);
                        } else {
                            navigate(`/kb/view/${item._id}${query}`);
                        }
                    }}
                    sx={{
                        width: "100%",
                        minWidth: 0,
                        marginBottom: "20px",
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                        cursor: "pointer",
                        "&:hover h4": { color: "#148DFD" },
                    }}
                >
                    <Box
                        component="h4"
                        title={item.title}
                        sx={{
                            color: "#0C141B",
                            fontFamily: "Inter",
                            fontSize: "16px",
                            fontStyle: "normal",
                            fontWeight: 700,
                            lineHeight: "24px",
                            margin: 0,
                            minWidth: 0,
                            maxWidth: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            transition: "color 0.2s ease",
                        }}
                    >
                        {item.title}
                    </Box>
                    <Box
                        sx={{
                            height: "1px",
                            width: "100%",
                            background: "#E5E9EC",
                            marginTop: "12px",
                        }}
                    />
                </Box>
            ))}
        </Box>
    );
};

export default RelatedArticles;
